<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>Organizational</h1>
       <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field
              label="Level 1"
              v-model="model.level1"
              :class="classPadding"
              autocomplete="off"
              readonly
              
            >
              <template slot="append">
                <v-icon @click.stop="search(1)" :disabled="!onEdit">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field
              label="Level 2"
              v-model="model.level2"
              :class="classPadding"
              autocomplete="off"
              readonly
               
            >
              <template slot="append">
                <v-icon @click.stop="search(2)" :disabled="!onEdit">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field
              label="Level 3"
              v-model="model.level3"
              :class="classPadding"
              autocomplete="off"
              readonly
               
            >
              <template slot="append">
                <v-icon @click.stop="search(3)" :disabled="!onEdit">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field
              label="Level 4"
              v-model="model.level4"
              :class="classPadding"
              autocomplete="off"
              readonly
               
            >
              <template slot="append">
                <v-icon @click.stop="search(4)" :disabled="!onEdit">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field
              label="Level 5"
              v-model="model.level5"
              :class="classPadding"
              autocomplete="off"
              readonly
               
            >
              <template slot="append">
                <v-icon @click.stop="search(5)" :disabled="!onEdit">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field
              label="Level 6"
              v-model="model.level6"
              :class="classPadding"
              autocomplete="off"
              readonly
            >
              <template slot="append" >
                <v-icon @click.stop="search(6)" :disabled="!onEdit">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" >
            <v-btn outlined text color="primary" @click.stop="edit">Edit</v-btn>&nbsp;
            <v-btn outlined text color="success" @click.stop="update" :disabled="!onEdit" :loading="loading">Update</v-btn>&nbsp;
            <v-btn outlined text @click.stop="cancel" :disabled="!onEdit">Cancel</v-btn>&nbsp;
            <v-btn outlined text @click.stop="clearAll" :disabled="!onEdit">Clear</v-btn>
          </v-col>
        </v-row>
    </v-container>

    <v-dialog v-model="dialog" width="700">
      <v-card>
        <v-card-title>
          <span class="headline">Hierarchy Level</span>
        </v-card-title>
        <v-card-text>
          <custom-table :items="items" :headers="headers" :loading="loading">
            <template slot="actions" slot-scope="{item}">
              <!-- <slot name="actions" v-bind:item="item"></slot> -->
              <v-btn @click.stop="select(item)" text outlined>Select</v-btn>
            </template>
          </custom-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.stop="dialog = false" text>CLose</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
const API_ENDPOINT = "/api/hierarchy"
import userAccessMixin from "../../../../mixins/userAccessMixin";
import CustomTable from "../../../../components/CustomTable";
import isEmpty from "lodash/isEmpty"
export default {
  metaInfo: {
    title: "Hierarchy Setup",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  data: () => ({
    classPadding: "my-0 py-0",
    model: {},
    onEdit: false,
    loading: false,
    dialog: false,
    items: [],
    headers: [
      { 
        text: '',
        value: "actions",
        sortable: false
      },
      {
        text: "Description",
        value: "description"
      }
    ],
    selectedLevel: 1
  }),
  components: {
    CustomTable
  },
  methods: {
    getSetup() {
      this.$axios.get(`${API_ENDPOINT}`)
        .then(({ data }) => {
          if(!isEmpty(data)){
             this.model = data;
          }
        })
        .catch(({ response }) => {
           this.$toast.error(response.data.message);
        })
    },
    search(level) {
      this.selectedLevel = level;
      this.dialog = true;
      this.$axios.post(`${API_ENDPOINT}/levels`, this.model)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({  response }) => {
          this.$toast.error(response.data.message);
        })

      
    },
    edit() {
      this.onEdit = true;
    },
    update() {
      this.loading = true;
      this.$axios.put(`${API_ENDPOINT}`, this.model)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.getSetup();
        })
        .catch(({  response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    cancel() {
      this.onEdit = false;
    },
    select(item) {

      if(this.selectedLevel != 1) {
        var previousLevel = this.selectedLevel - 1;

        if(this.model[`level${previousLevel}`] == "" || typeof this.model[`level${previousLevel}`] === "undefined") {
          this.$toast.error("Please select next level."); return;
        }
      }
     


      if(this.selectedLevel == "1"){
        this.model.level1 = item.description
      }else if(this.selectedLevel == "2"){
        this.model.level2 = item.description
      }else if(this.selectedLevel == "3"){
        this.model.level3 = item.description
      }else if(this.selectedLevel == "4"){
        this.model.level4 = item.description
      }else if(this.selectedLevel == "5"){
        this.model.level5 = item.description
      }else if(this.selectedLevel == "6"){
        this.model.level6 = item.description
      }

      this.dialog = false;
    },
    enableDisable(level){
      if(this.onEdit){
        var nextLevel = level + 1;
        
        if(this.model[`level${level}`] !== "" || typeof this.model[`level${level}`] !== 'undefined') {
           if(this.model[`level${nextLevel}`]  == "" || typeof this.model[`level${level}`] === 'undefined') {
             return false;
           }else{
             return true;
           }
        }else {
          return true;
        }
        
      }
    },
    clearAll(){
      this.model = {}
    }
  },
  created() {
    this.getUserAccessRights("Hierarchy");
    this.getSetup();
  }
}
</script>